import { PropsWithChildren } from 'react';
import { cn } from '../../lib/utils';

interface CenteredStackProps extends PropsWithChildren {
  spacing?: number;
  className?: string;
}

export function CenteredStack({ children, spacing, className }: CenteredStackProps) {
  const gapClass = spacing ? `gap-${spacing}` : 'gap-2';

  return (
    <div className={cn('my-4 flex flex-col items-center', gapClass, className)}>{children}</div>
  );
}
